import { Component, OnInit } from '@angular/core'
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service'
import { MetaService } from 'src/app/shared/services/meta.service'

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  constructor(
    private breadcrumbService: BreadcrumbService,
    private metaService: MetaService
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbLinks.next([{ label: 'About' }])
    this.metaService.setTags('about')
  }
}
